
import { Sale } from "@/models/base";
import AppSignSaleModalBase from "@/components/sales/SignSaleModalBase.vue";

import Vue from "vue";
import { ClientPortalService } from "@/services/client-portal-service";

export default Vue.extend({
	data() {
		return {
			token: ""
		};
	},
	props: {
		sale: {
			type: Object as () => Sale,
			required: true
		},
		eToken: {
			type: String,
			required: true
		},
	},
	computed: {

	},
	methods: {
		close() {
			this.$emit("close");
		},
		async doConfirm(signedBy:string,blob:Blob) {
			await ClientPortalService.signSale(this.token,signedBy,blob);
			this.$emit("signed");
			this.close();
		}
	},
	created(){
		this.token = this.eToken ? this.eToken : this.$route.params.token;
	},
	components: {
		AppSignSaleModalBase
	},
	i18nEx: {
		componentPrefix: "components.client-portal"
	}
});
